import { Col, Row } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import image from "../../assets/images/five.jpg";
import { formatLastModified } from "../../utils/TimeConvert";
import LoadingCom from "../LoadingCom";

const ProjectsData = ({ projectsData, title, Imageloading }) => {
  console.log(projectsData, "projectDataDetailsssss");
  const navigate = useNavigate();
  return (
    <Row gutter={[10, 10]}>
      {projectsData?.length > 0 ? (
        projectsData?.map((project) => (
          <Col
            // lg={8}
            md={12}
            key={project.id}
            className="cursor-pointer"
            onClick={() =>
              navigate(`/projects/${project.id}`, {
                state: { data: project },
              })
            }
          >
            <div className="bg-pureWhite rounded-xl shadow-signupBoxShadow p-3 h-full">
              {Imageloading ? (
                <LoadingCom />
              ) : (
                <img
                  className="rounded-lg h-[200px] w-full shadow-profileShadow"
                  src={project?.properties && project?.properties[0]?.resources}
                  alt={project?.id}
                  // width={400}
                  // height={140}
                />
              )}
              <div className="flex justify-between items-center mt-2">
                <p className="text-base text-DarkGrey font-semibold w-[80%]">
                  {project?.properties && project?.properties[1]?.value}
                </p>
              </div>
              <div className="flex mt-2 justify-between items-center">
                <p className="text-sm text-DarkGrey ">
                  No. of Ideas:
                  <span className="font-bold">
                    {project?.properties && project?.properties[3]?.value}
                  </span>
                </p>
              </div>
              <div className="flex justify-between">
                <p className="flex text-[10px] justify-between mt-2 text-gray-400">
                  Closing Date of Submission: <br />
                  {project?.properties && project?.properties[4]?.value}
                  {/* {formatLastModified(project?.lastChange)} */}
                </p>
                <p className="flex items-center gap-x-2 text-[10px] text-gray-400">
                  <span className="font-bold">
                    Status:
                    {/* <ClockIcon /> */}
                  </span>
                  {/* <span>{course?.duration}</span> */}
                  <span>
                    {" "}
                    {project?.properties &&
                      project?.properties[2]?.values[0]?.value}
                  </span>
                </p>
              </div>

              <div className="flex justify-between items-center mt-2">
                <p className="flex items-center gap-x-2 text-[10px] text-gray-400">
                  <span>{/* <LocationIcon /> */}</span>
                  {/* <span>{course?.location}</span> */}
                  {/* <span>City, Country</span> */}
                </p>
                <p className="flex items-center gap-x-2 text-[10px] text-gray-400">
                  {/* {course?.contentType} */}
                  {/* <GradientButton className={"w-48"}>
                      View Campaign
                      </GradientButton> */}
                </p>
              </div>
            </div>
          </Col>
        ))
      ) : (
        <div className="w-full">
          <LoadingCom />
        </div>
      )}
    </Row>
  );
};

export default ProjectsData;
